import React from "react";

import { MarginaliaGroup } from "../../../components/ContentBuilder/MarginaliaGroup/MarginaliaGroup";
import { MarginaliaTitle } from "../../../components/ContentBuilder/MarginaliaTitle/MarginaliaTitle";
import { MarginaliaButton } from "../../../components/ContentBuilder/MarginaliaButton/MarginaliaButton";
import { MarginaliaInfoBox } from "../../../components/ContentBuilder/MarginaliaInfoBox/MarginaliaInfoBox";
import { MarginaliaData } from "../../../components/ContentBuilder/ContentBuilder.type";

import { downloadChartPng } from "./downloadFile";

interface ChartMarginaliaOptions {
	/** Replaces the default "CHART" label, e.g. "CHART 1.1". Pass null to hide the label altogether. */
	label?: string | null;
	infoBox?: { title: string; body: string };
}

export const createChartMarginalia = (source: string, id: string, pngFilename?: string, { label = "CHART", infoBox }: ChartMarginaliaOptions = {}): MarginaliaData => ({
	component: MarginaliaGroup,
	props: {
		children: [
			...(label ? [<MarginaliaTitle key="title" title={label} />] : []),
			...(pngFilename ? [<MarginaliaButton key="download" variant="download" label="Download chart" sublabel="PNG • high resolution" onClick={() => downloadChartPng(pngFilename)} />] : []),
			<MarginaliaButton key="copy" variant="copy" label="Copy link to this chart" clickedLabel="Link copied" onClick={() => navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}#${id}`)} />,
			...(infoBox ? [<MarginaliaInfoBox key="infobox" title={infoBox.title} body={infoBox.body} />] : []),
			<MarginaliaInfoBox key="source" title="Source" body={source} />,
		],
	},
});
